import { useEffect } from "react";
import Modal from "../../../components/ui/Modal";
import { useForm } from "react-hook-form";
import FieldError from "../../../components/ui/FieldError";
import RequiredField from "../../../components/ui/RequiredField";
import axiosConfig from "../../../services/Axios";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

function ContactForm({
  partner,
  setPartner,
  partnerContactSelected,
  modalIsOpen,
  setIsOpen,
}) {
  const form = useForm();
  const { t } = useTranslation();

  const onSubmitPartnerContact = async (data) => {
    data.partner = partner["@id"];

    try {
      if (partnerContactSelected) {
        await axiosConfig
          .patch(
            process.env.REACT_APP_API_URL + partnerContactSelected["@id"],
            data,
            {
              headers: { "Content-Type": "application/merge-patch+json" },
            }
          )
          .then((response) => {
            if (response?.status === 200 && response?.data) {
              toast.success(t("global.changes_saved"), {
                theme: "colored",
                hideProgressBar: true,
              });

              let newPartnerContacts = partner.partnerContacts.map((pc) =>
                pc["@id"] === partnerContactSelected["@id"] ? response.data : pc
              );
              partner.partnerContacts = newPartnerContacts;
            }
          });
      } else {
        await axiosConfig
          .post(process.env.REACT_APP_API_URL + "/api/partner_contacts", data)
          .then((response) => {
            if (response?.status === 201 && response?.data) {
              toast.success(t("partnerContact.created"), {
                theme: "colored",
                hideProgressBar: true,
              });

              let newPartnerContacts = partner.partnerContacts.concat(
                response.data
              );
              partner.partnerContacts = newPartnerContacts;
            }
          });
      }

      setIsOpen(false);
    } catch (e) {
      if (e.response.status !== 200 && e.response.data?.violations) {
        e.response.data.violations.map((v) => {
          form.setError(v.propertyPath, {
            type: "manual",
            message: v.message,
          });
        });
      }
    }
  };

  useEffect(() => {
    form.reset();
  }, [modalIsOpen]);

  return (
    <div>
      <Modal
        showModal={modalIsOpen}
        setShowModal={setIsOpen}
        title={
          partnerContactSelected
            ? t("partnerContact.edit")
            : t("partnerContact.create")
        }
        sendLabel={t("global.btn.save")}
        onSubmit={form.handleSubmit(onSubmitPartnerContact)}
      >
        <form onSubmit={form.handleSubmit(onSubmitPartnerContact)}>
          <div className="grid grid-cols-12 gap-3">
            <div className="col-span-6">
              <label>
                {t("user.firstName")} <RequiredField /> :
              </label>
              <input
                {...form.register("firstName")}
                name="firstName"
                type="text"
                className="w-full"
                defaultValue={partnerContactSelected?.firstName}
                aria-invalid={form.formState?.errors?.firstName ? true : false}
              />
              <FieldError error={form.formState?.errors?.firstName} />
            </div>

            <div className="col-span-6">
              <label>
                {t("user.lastName")} <RequiredField /> :
              </label>
              <input
                {...form.register("lastName")}
                name="lastName"
                type="text"
                className="w-full"
                defaultValue={partnerContactSelected?.lastName}
                aria-invalid={form.formState?.errors?.lastName ? true : false}
              />
              <FieldError error={form.formState?.errors?.lastName} />
            </div>

            <div className="col-span-6">
              <label>
                {t("login.email")} <RequiredField /> :
              </label>
              <input
                {...form.register("email")}
                name="email"
                type="text"
                className="w-full"
                defaultValue={partnerContactSelected?.email}
                aria-invalid={form.formState?.errors?.email ? true : false}
              />
              <FieldError error={form.formState?.errors?.email} />
            </div>

            <div className="col-span-6">
              <label>
                {t("user.phoneNumber")} <RequiredField /> :
              </label>
              <input
                {...form.register("phoneNumber")}
                name="phoneNumber"
                type="text"
                className="w-full"
                defaultValue={partnerContactSelected?.phoneNumber}
                aria-invalid={
                  form.formState?.errors?.phoneNumber ? true : false
                }
              />
              <FieldError error={form.formState?.errors?.phoneNumber} />
            </div>
          </div>
          <input type="submit" className="hidden" />
        </form>
      </Modal>
    </div>
  );
}

export default ContactForm;
